// NumeroVastuDefaultData.js — Lo Shu Grid data for Numero Vastu report

// Per-number data: color, direction, planet, element, use
export const LO_SHU_DATA = {
  1: { color:'#3B82F6', colorRgb:[59,130,246],  direction:'North',      planet:'Sun',     element:'Water',       use:'Career & Success' },
  2: { color:'#EF4444', colorRgb:[239,68,68],   direction:'South West', planet:'Moon',    element:'Earth',       use:'Marriage & Relationship' },
  3: { color:'#22C55E', colorRgb:[34,197,94],   direction:'East',       planet:'Jupiter', element:'Hard Wood',   use:'Health & Family' },
  4: { color:'#8B5CF6', colorRgb:[139,92,246],  direction:'South East', planet:'Rahu',    element:'Soft Wood',   use:'Money & Property' },
  5: { color:'#CA8A04', colorRgb:[202,138,4],   direction:'Center',     planet:'Mercury', element:'Earth',       use:'Energy & Stability' },
  6: { color:'#1E3A5F', colorRgb:[30,58,95],    direction:'North West', planet:'Venus',   element:'Hard Metal',  use:'Friends & Beginnings' },
  7: { color:'#0D9488', colorRgb:[13,148,136],  direction:'West',       planet:'Ketu',    element:'Soft Metal',  use:'Children & Creativity' },
  8: { color:'#EA580C', colorRgb:[234,88,12],   direction:'North East', planet:'Saturn',  element:'Earth',       use:'Knowledge & Intuition' },
  9: { color:'#6B7280', colorRgb:[107,114,128], direction:'South',      planet:'Mars',    element:'Fire',        use:'Fame & Prosperity' },
};

// Lo Shu Grid layout — row by row (fixed)
export const LO_SHU_GRID = [
  [4, 9, 2],
  [3, 5, 7],
  [8, 1, 6],
];

// Every predefined remedy line now carries all 8 supported languages instead
// of a plain English string — read via pickLang(value, lang) from
// i18n/languageOptions.js at the point of use (see buildDefaultHtml in
// NumeroVastuReport.jsx). `tr()` is just a short constructor so this table
// stays scannable; the language keys always match LANGUAGE_OPTIONS' codes.
const tr = (en, hi, gu, mr, bn, kn, ta, te) => ({ en, hi, gu, mr, bn, kn, ta, te });

// Fixed section labels used by buildDefaultHtml() in NumeroVastuReport.jsx.
export const NUMERO_REMEDY_LABELS = {
  missingNumber: tr('Missing Number', 'अनुपस्थित अंक', 'ગુમ થયેલ અંક', 'गहाळ अंक', 'অনুপস্থিত সংখ্যা', 'ಕಾಣೆಯಾದ ಸಂಖ್ಯೆ', 'விடுபட்ட எண்', 'తప్పిపోయిన సంఖ్య'),
  direction:     tr('Direction:', 'दिशा:', 'દિશા:', 'दिशा:', 'দিক:', 'ದಿಕ್ಕು:', 'திசை:', 'దిశ:'),
  planet:        tr('Planet:', 'ग्रह:', 'ગ્રહ:', 'ग्रह:', 'গ্রহ:', 'ಗ್ರಹ:', 'கிரகம்:', 'గ్రహం:'),
  mindRemedies:  tr('Mind Remedies', 'मन के उपाय', 'મન માટે ઉપાયો', 'मनासाठी उपाय', 'মনের প্রতিকার', 'ಮನಸ್ಸಿನ ಪರಿಹಾರಗಳು', 'மன பரிகாரங்கள்', 'మనసుకు పరిష్కారాలు'),
  bodyRemedies:  tr('Body Remedies', 'शरीर के उपाय', 'શરીર માટે ઉપાયો', 'शरीरासाठी उपाय', 'শরীরের প্রতিকার', 'ದೇಹದ ಪರಿಹಾರಗಳು', 'உடல் பரிகாரங்கள்', 'శరీరానికి పరిష్కారాలు'),
  soulRemedies:  tr('Soul Remedies', 'आत्मा के उपाय', 'આત્મા માટે ઉપાયો', 'आत्म्यासाठी उपाय', 'আত্মার প্রতিকার', 'ಆತ್ಮದ ಪರಿಹಾರಗಳು', 'ஆன்மா பரிகாரங்கள்', 'ఆత్మకు పరిష్కారాలు'),
};

// Missing number remedies — Mind, Body, Soul
export const MISSING_NUMBER_REMEDIES = {
  1: {
    mind: [
      tr('Keep Fountain or aquarium in north zone of house',
         'घर के उत्तर क्षेत्र में फव्वारा या एक्वेरियम रखें',
         'ઘરના ઉત્તર ઝોનમાં ફુવારો અથવા માછલીઘર રાખો',
         'घराच्या उत्तर भागात कारंजे किंवा मत्स्यालय ठेवा',
         'বাড়ির উত্তর অংশে ফোয়ারা বা অ্যাকোয়ারিয়াম রাখুন',
         'ಮನೆಯ ಉತ್ತರ ವಲಯದಲ್ಲಿ ಕಾರಂಜಿ ಅಥವಾ ಅಕ್ವೇರಿಯಂ ಇಡಿ',
         'வீட்டின் வடக்குப் பகுதியில் நீரூற்று அல்லது மீன் தொட்டி வையுங்கள்',
         'ఇంటి ఉత్తర భాగంలో ఫౌంటెన్ లేదా అక్వేరియం ఉంచండి'),
      tr('Keep Sun Picture in east zone',
         'पूर्व क्षेत्र में सूर्य की तस्वीर रखें',
         'પૂર્વ ઝોનમાં સૂર્યનું ચિત્ર રાખો',
         'पूर्व भागात सूर्याचे चित्र ठेवा',
         'পূর্ব অংশে সূর্যের ছবি রাখুন',
         'ಪೂರ್ವ ವಲಯದಲ್ಲಿ ಸೂರ್ಯನ ಚಿತ್ರ ಇಡಿ',
         'கிழக்குப் பகுதியில் சூரியனின் படத்தை வையுங்கள்',
         'తూర్పు భాగంలో సూర్యుని చిత్రం ఉంచండి'),
      tr('Draw one Swastika in east',
         'पूर्व दिशा में एक स्वस्तिक बनाएं',
         'પૂર્વ દિશામાં એક સ્વસ્તિક દોરો',
         'पूर्व दिशेला एक स्वस्तिक काढा',
         'পূর্ব দিকে একটি স্বস্তিক আঁকুন',
         'ಪೂರ್ವ ದಿಕ್ಕಿನಲ್ಲಿ ಒಂದು ಸ್ವಸ್ತಿಕ ಬಿಡಿಸಿ',
         'கிழக்கு திசையில் ஒரு ஸ்வஸ்திகா வரையுங்கள்',
         'తూర్పు దిశలో ఒక స్వస్తిక గీయండి'),
    ],
    body: [
      tr('Keep Copper coins in orange cloth',
         'नारंगी कपड़े में तांबे के सिक्के रखें',
         'નારંગી કપડામાં તાંબાના સિક્કા રાખો',
         'नारिंगी कापडात तांब्याची नाणी ठेवा',
         'কমলা কাপড়ে তামার মুদ্রা রাখুন',
         'ಕಿತ್ತಳೆ ಬಟ್ಟೆಯಲ್ಲಿ ತಾಮ್ರದ ನಾಣ್ಯಗಳನ್ನು ಇಡಿ',
         'ஆரஞ்சு துணியில் செம்பு நாணயங்களை வையுங்கள்',
         'నారింజ రంగు గుడ్డలో రాగి నాణేలు ఉంచండి'),
      tr('Keep Sun Yantra',
         'सूर्य यंत्र रखें',
         'સૂર્ય યંત્ર રાખો',
         'सूर्य यंत्र ठेवा',
         'সূর্য যন্ত্র রাখুন',
         'ಸೂರ್ಯ ಯಂತ್ರ ಇಡಿ',
         'சூரிய யந்திரம் வையுங்கள்',
         'సూర్య యంత్రం ఉంచండి'),
      tr('Apply red tilak on forehead daily',
         'रोज़ माथे पर लाल तिलक लगाएं',
         'રોજ કપાળ પર લાલ તિલક લગાવો',
         'दररोज कपाळावर लाल टिळा लावा',
         'প্রতিদিন কপালে লাল তিলক লাগান',
         'ಪ್ರತಿದಿನ ಹಣೆಗೆ ಕೆಂಪು ತಿಲಕ ಹಚ್ಚಿ',
         'தினமும் நெற்றியில் சிவப்பு திலகம் இடுங்கள்',
         'ప్రతిరోజు నుదుటిపై ఎరుపు తిలకం పెట్టుకోండి'),
    ],
    soul: [
      tr('Worship Lord Shiva',
         'भगवान शिव की पूजा करें',
         'ભગવાન શિવની પૂજા કરો',
         'भगवान शिवाची पूजा करा',
         'ভগবান শিবের পূজা করুন',
         'ಶಿವನನ್ನು ಪೂಜಿಸಿ',
         'சிவபெருமானை வழிபடுங்கள்',
         'శివుడిని పూజించండి'),
      tr('Give water to Sun daily',
         'रोज़ सूर्य को जल अर्पित करें',
         'રોજ સૂર્યને જળ અર્પણ કરો',
         'दररोज सूर्याला पाणी अर्पण करा',
         'প্রতিদিন সূর্যকে জল অর্পণ করুন',
         'ಪ್ರತಿದಿನ ಸೂರ್ಯನಿಗೆ ನೀರು ಅರ್ಪಿಸಿ',
         'தினமும் சூரியனுக்கு நீர் அர்ப்பணியுங்கள்',
         'ప్రతిరోజు సూర్యునికి నీరు సమర్పించండి'),
      tr('Avoid salt on Sunday',
         'रविवार को नमक से परहेज़ करें',
         'રવિવારે મીઠું ટાળો',
         'रविवारी मीठ टाळा',
         'রবিবার লবণ এড়িয়ে চলুন',
         'ಭಾನುವಾರ ಉಪ್ಪನ್ನು ತ್ಯಜಿಸಿ',
         'ஞாயிற்றுக்கிழமை உப்பைத் தவிருங்கள்',
         'ఆదివారం ఉప్పు మానుకోండి'),
    ],
  },
  2: {
    mind: [
      tr('Keep a pair of white objects in the North-West zone of house',
         'घर के उत्तर-पश्चिम क्षेत्र में सफेद वस्तुओं की एक जोड़ी रखें',
         'ઘરના ઉત્તર-પશ્ચિમ ઝોનમાં સફેદ વસ્તુઓની જોડી રાખો',
         'घराच्या वायव्य भागात पांढऱ्या वस्तूंची जोडी ठेवा',
         'বাড়ির উত্তর-পশ্চিম অংশে সাদা জিনিসের একজোড়া রাখুন',
         'ಮನೆಯ ವಾಯುವ್ಯ ವಲಯದಲ್ಲಿ ಬಿಳಿ ವಸ್ತುಗಳ ಒಂದು ಜೋಡಿ ಇಡಿ',
         'வீட்டின் வடமேற்குப் பகுதியில் வெள்ளை பொருட்களின் ஜோடி ஒன்றை வையுங்கள்',
         'ఇంటి వాయవ్య భాగంలో తెల్లని వస్తువుల జత ఉంచండి'),
      tr('Keep Moon picture in North-West zone',
         'उत्तर-पश्चिम क्षेत्र में चंद्रमा की तस्वीर रखें',
         'ઉત્તર-પશ્ચિમ ઝોનમાં ચંદ્રનું ચિત્ર રાખો',
         'वायव्य भागात चंद्राचे चित्र ठेवा',
         'উত্তর-পশ্চিম অংশে চাঁদের ছবি রাখুন',
         'ವಾಯುವ್ಯ ವಲಯದಲ್ಲಿ ಚಂದ್ರನ ಚಿತ್ರ ಇಡಿ',
         'வடமேற்குப் பகுதியில் சந்திரனின் படத்தை வையுங்கள்',
         'వాయవ్య భాగంలో చంద్రుని చిత్రం ఉంచండి'),
      tr('Keep a water element in North-West',
         'उत्तर-पश्चिम में जल तत्व रखें',
         'ઉત્તર-પશ્ચિમમાં જળ તત્વ રાખો',
         'वायव्येला जलतत्व ठेवा',
         'উত্তর-পশ্চিমে জলের উপাদান রাখুন',
         'ವಾಯುವ್ಯದಲ್ಲಿ ಜಲ ತತ್ವವನ್ನು ಇಡಿ',
         'வடமேற்கில் நீர் தொடர்பான பொருளை வையுங்கள்',
         'వాయవ్యంలో నీటి తత్వాన్ని ఉంచండి'),
    ],
    body: [
      tr('Wear a silver chain',
         'चांदी की चेन पहनें',
         'ચાંદીની ચેન પહેરો',
         'चांदीची साखळी घाला',
         'রূপার চেইন পরুন',
         'ಬೆಳ್ಳಿಯ ಸರವನ್ನು ಧರಿಸಿ',
         'வெள்ளி சங்கிலி அணியுங்கள்',
         'వెండి గొలుసు ధరించండి'),
      tr('Keep Moon Yantra',
         'चंद्र यंत्र रखें',
         'ચંદ્ર યંત્ર રાખો',
         'चंद्र यंत्र ठेवा',
         'চন্দ্র যন্ত্র রাখুন',
         'ಚಂದ್ರ ಯಂತ್ರ ಇಡಿ',
         'சந்திர யந்திரம் வையுங்கள்',
         'చంద్ర యంత్రం ఉంచండి'),
      tr('Keep a white handkerchief with you',
         'अपने पास एक सफेद रुमाल रखें',
         'તમારી પાસે સફેદ રૂમાલ રાખો',
         'तुमच्याजवळ पांढरा रुमाल ठेवा',
         'নিজের কাছে একটি সাদা রুমাল রাখুন',
         'ನಿಮ್ಮ ಬಳಿ ಬಿಳಿ ಕರವಸ್ತ್ರವನ್ನು ಇಟ್ಟುಕೊಳ್ಳಿ',
         'உங்களுடன் ஒரு வெள்ளை கைக்குட்டையை வையுங்கள்',
         'మీ వద్ద తెల్లని రుమాలు ఉంచుకోండి'),
    ],
    soul: [
      tr('Worship Lord Shiva',
         'भगवान शिव की पूजा करें',
         'ભગવાન શિવની પૂજા કરો',
         'भगवान शिवाची पूजा करा',
         'ভগবান শিবের পূজা করুন',
         'ಶಿವನನ್ನು ಪೂಜಿಸಿ',
         'சிவபெருமானை வழிபடுங்கள்',
         'శివుడిని పూజించండి'),
      tr('Offer water/milk to Shiva',
         'शिव को जल/दूध अर्पित करें',
         'શિવને જળ/દૂધ અર્પણ કરો',
         'शिवाला पाणी/दूध अर्पण करा',
         'শিবকে জল/দুধ অর্পণ করুন',
         'ಶಿವನಿಗೆ ನೀರು/ಹಾಲು ಅರ್ಪಿಸಿ',
         'சிவனுக்கு நீர்/பால் அர்ப்பணியுங்கள்',
         'శివునికి నీరు/పాలు సమర్పించండి'),
      tr('Respect mother and elderly women',
         'माता और बड़ी उम्र की महिलाओं का सम्मान करें',
         'માતા અને વૃદ્ધ મહિલાઓનું સન્માન કરો',
         'आई आणि वयोवृद्ध स्त्रियांचा आदर करा',
         'মা এবং বয়স্ক মহিলাদের সম্মান করুন',
         'ತಾಯಿ ಮತ್ತು ಹಿರಿಯ ಮಹಿಳೆಯರನ್ನು ಗೌರವಿಸಿ',
         'தாயையும் முதிய பெண்களையும் மதியுங்கள்',
         'తల్లిని మరియు వృద్ధ మహిళలను గౌరవించండి'),
    ],
  },
  3: {
    mind: [
      tr('Place sceneries of green plants in east',
         'पूर्व दिशा में हरे पौधों के चित्र लगाएं',
         'પૂર્વ દિશામાં લીલા છોડના દ્રશ્યો મૂકો',
         'पूर्व दिशेला हिरव्या झाडांची चित्रे ठेवा',
         'পূর্ব দিকে সবুজ গাছপালার দৃশ্য রাখুন',
         'ಪೂರ್ವ ದಿಕ್ಕಿನಲ್ಲಿ ಹಸಿರು ಗಿಡಗಳ ಚಿತ್ರಗಳನ್ನು ಇಡಿ',
         'கிழக்கு திசையில் பச்சை தாவரங்களின் காட்சிகளை வையுங்கள்',
         'తూర్పు దిశలో పచ్చని మొక్కల చిత్రాలను ఉంచండి'),
      tr('Place Lord Brahma Picture in west',
         'पश्चिम में भगवान ब्रह्मा की तस्वीर लगाएं',
         'પશ્ચિમમાં ભગવાન બ્રહ્માનું ચિત્ર મૂકો',
         'पश्चिमेला भगवान ब्रह्मदेवाचे चित्र ठेवा',
         'পশ্চিমে ভগবান ব্রহ্মার ছবি রাখুন',
         'ಪಶ್ಚಿಮದಲ್ಲಿ ಬ್ರಹ್ಮ ದೇವರ ಚಿತ್ರವನ್ನು ಇಡಿ',
         'மேற்கில் பிரம்மா தேவரின் படத்தை வையுங்கள்',
         'పడమర దిశలో బ్రహ్మదేవుని చిత్రం ఉంచండి'),
      tr('Keep objects made of wood like wooden craft, table, glass, clock etc.',
         'लकड़ी की कलाकृति, मेज़, कांच, घड़ी जैसी लकड़ी की बनी वस्तुएं रखें',
         'લાકડાની હસ્તકલા, ટેબલ, કાચ, ઘડિયાળ જેવી લાકડાની વસ્તુઓ રાખો',
         'लाकडी हस्तकला, टेबल, काच, घड्याळ यांसारख्या लाकडी वस्तू ठेवा',
         'কাঠের হস্তশিল্প, টেবিল, কাচ, ঘড়ির মতো কাঠের তৈরি জিনিস রাখুন',
         'ಮರದ ಕರಕುಶಲ ವಸ್ತು, ಟೇಬಲ್, ಗಾಜು, ಗಡಿಯಾರದಂತಹ ಮರದ ವಸ್ತುಗಳನ್ನು ಇಡಿ',
         'மர கைவினைப் பொருள், மேசை, கண்ணாடி, கடிகாரம் போன்ற மரப் பொருட்களை வையுங்கள்',
         'చెక్క హస్తకళ, టేబుల్, గాజు, గడియారం వంటి చెక్క వస్తువులను ఉంచండి'),
    ],
    body: [
      tr('Tie Yellow thread on wrist',
         'कलाई पर पीला धागा बांधें',
         'કાંડા પર પીળો દોરો બાંધો',
         'मनगटावर पिवळा धागा बांधा',
         'কব্জিতে হলুদ সুতো বাঁধুন',
         'ಮಣಿಕಟ್ಟಿಗೆ ಹಳದಿ ದಾರವನ್ನು ಕಟ್ಟಿ',
         'மணிக்கட்டில் மஞ்சள் நூல் கட்டுங்கள்',
         'మణికట్టుకు పసుపు దారం కట్టుకోండి'),
      tr('Keep Jupiter Yantra',
         'बृहस्पति यंत्र रखें',
         'ગુરુ યંત્ર રાખો',
         'गुरु यंत्र ठेवा',
         'বৃহস্পতি যন্ত্র রাখুন',
         'ಗುರು ಯಂತ್ರ ಇಡಿ',
         'குரு யந்திரம் வையுங்கள்',
         'గురు యంత్రం ఉంచండి'),
      tr('Keep wooden pen or wooden key ring with you',
         'अपने पास लकड़ी की कलम या लकड़ी की चाबी की रिंग रखें',
         'તમારી પાસે લાકડાની પેન અથવા લાકડાની કી રિંગ રાખો',
         'तुमच्याजवळ लाकडी पेन किंवा लाकडी की-रिंग ठेवा',
         'নিজের কাছে কাঠের কলম বা কাঠের কী-রিং রাখুন',
         'ನಿಮ್ಮ ಬಳಿ ಮರದ ಪೆನ್ ಅಥವಾ ಮರದ ಕೀ ರಿಂಗ್ ಇಟ್ಟುಕೊಳ್ಳಿ',
         'உங்களுடன் மரப் பேனா அல்லது மர சாவி வளையத்தை வையுங்கள்',
         'మీ వద్ద చెక్క పెన్ను లేదా చెక్క కీ రింగ్ ఉంచుకోండి'),
    ],
    soul: [
      tr('Chant Gayatri Mantra daily',
         'रोज़ गायत्री मंत्र का जाप करें',
         'રોજ ગાયત્રી મંત્રનો જાપ કરો',
         'दररोज गायत्री मंत्राचा जप करा',
         'প্রতিদিন গায়ত্রী মন্ত্র জপ করুন',
         'ಪ್ರತಿದಿನ ಗಾಯತ್ರಿ ಮಂತ್ರ ಜಪಿಸಿ',
         'தினமும் காயத்ரி மந்திரத்தை ஜபியுங்கள்',
         'ప్రతిరోజు గాయత్రీ మంత్రం జపించండి'),
      tr('Respect old people and your teachers',
         'बड़े-बुजुर्गों और अपने गुरुजनों का सम्मान करें',
         'વડીલો અને તમારા શિક્ષકોનું સન્માન કરો',
         'वडीलधारी माणसे आणि आपल्या गुरुजनांचा आदर करा',
         'বয়স্কদের এবং আপনার শিক্ষকদের সম্মান করুন',
         'ಹಿರಿಯರನ್ನು ಮತ್ತು ನಿಮ್ಮ ಗುರುಗಳನ್ನು ಗೌರವಿಸಿ',
         'பெரியவர்களையும் உங்கள் ஆசிரியர்களையும் மதியுங்கள்',
         'పెద్దలను మరియు మీ గురువులను గౌరవించండి'),
      tr('Apply Saffron Tilak daily',
         'रोज़ केसर का तिलक लगाएं',
         'રોજ કેસરનું તિલક લગાવો',
         'दररोज केशरी टिळा लावा',
         'প্রতিদিন জাফরানের তিলক লাগান',
         'ಪ್ರತಿದಿನ ಕುಂಕುಮ ತಿಲಕ ಹಚ್ಚಿ',
         'தினமும் குங்குமப்பூ திலகம் இடுங்கள்',
         'ప్రతిరోజు కుంకుమ తిలకం పెట్టుకోండి'),
    ],
  },
  4: {
    mind: [
      tr('Keep house and surroundings clean',
         'घर और आस-पास की जगह साफ रखें',
         'ઘર અને આસપાસનું વાતાવરણ સ્વચ્છ રાખો',
         'घर आणि आजूबाजूचा परिसर स्वच्छ ठेवा',
         'বাড়ি এবং আশপাশের জায়গা পরিষ্কার রাখুন',
         'ಮನೆ ಮತ್ತು ಸುತ್ತಮುತ್ತಲಿನ ಪ್ರದೇಶವನ್ನು ಸ್ವಚ್ಛವಾಗಿಡಿ',
         'வீட்டையும் சுற்றுப்புறத்தையும் சுத்தமாக வையுங்கள்',
         'ఇంటిని మరియు చుట్టుపక్కల ప్రాంతాన్ని పరిశుభ్రంగా ఉంచండి'),
      tr('Balance South-West zone of your house',
         'अपने घर के दक्षिण-पश्चिम क्षेत्र को संतुलित रखें',
         'તમારા ઘરના દક્ષિણ-પશ્ચિમ ઝોનને સંતુલિત રાખો',
         'तुमच्या घराचा नैऋत्य भाग संतुलित ठेवा',
         'আপনার বাড়ির দক্ষিণ-পশ্চিম অংশ সুষম রাখুন',
         'ನಿಮ್ಮ ಮನೆಯ ನೈऋತ್ಯ ವಲಯವನ್ನು ಸಮತೋಲನದಲ್ಲಿಡಿ',
         'உங்கள் வீட்டின் தென்மேற்குப் பகுதியை சமநிலையில் வையுங்கள்',
         'మీ ఇంటి నైరుతి భాగాన్ని సమతుల్యంగా ఉంచండి'),
      tr('Keep green plant in South-east of house',
         'घर के दक्षिण-पूर्व में हरा पौधा रखें',
         'ઘરના દક્ષિણ-પૂર્વમાં લીલો છોડ રાખો',
         'घराच्या आग्नेय भागात हिरवी वनस्पती ठेवा',
         'বাড়ির দক্ষিণ-পূর্বে সবুজ গাছ রাখুন',
         'ಮನೆಯ ಆಗ್ನೇಯದಲ್ಲಿ ಹಸಿರು ಸಸ್ಯವನ್ನು ಇಡಿ',
         'வீட்டின் தென்கிழக்கில் பச்சை செடியை வையுங்கள்',
         'ఇంటి ఆగ్నేయంలో పచ్చని మొక్కను ఉంచండి'),
    ],
    body: [
      tr('Keep some Barley in brown cloth',
         'भूरे कपड़े में थोड़ी जौ रखें',
         'બ્રાઉન કપડામાં થોડો જવ રાખો',
         'तपकिरी कापडात थोडी बार्ली ठेवा',
         'বাদামী কাপড়ে কিছু যব রাখুন',
         'ಕಂದು ಬಟ್ಟೆಯಲ್ಲಿ ಸ್ವಲ್ಪ ಬಾರ್ಲಿ ಇಡಿ',
         'பழுப்பு நிற துணியில் சிறிது வாற்கோதுமையை வையுங்கள்',
         'గోధుమ రంగు గుడ్డలో కొంచెం బార్లీని ఉంచండి'),
      tr('Keep Rahu Yantra',
         'राहु यंत्र रखें',
         'રાહુ યંત્ર રાખો',
         'राहू यंत्र ठेवा',
         'রাহু যন্ত্র রাখুন',
         'ರಾಹು ಯಂತ್ರ ಇಡಿ',
         'ராகு யந்திரம் வையுங்கள்',
         'రాహు యంత్రం ఉంచండి'),
      tr('Keep wooden pen or key ring with you',
         'अपने पास लकड़ी की कलम या चाबी की रिंग रखें',
         'તમારી પાસે લાકડાની પેન અથવા કી રિંગ રાખો',
         'तुमच्याजवळ लाकडी पेन किंवा की-रिंग ठेवा',
         'নিজের কাছে কাঠের কলম বা কী-রিং রাখুন',
         'ನಿಮ್ಮ ಬಳಿ ಮರದ ಪೆನ್ ಅಥವಾ ಕೀ ರಿಂಗ್ ಇಟ್ಟುಕೊಳ್ಳಿ',
         'உங்களுடன் மரப் பேனா அல்லது சாவி வளையத்தை வையுங்கள்',
         'మీ వద్ద చెక్క పెన్ను లేదా కీ రింగ్ ఉంచుకోండి'),
    ],
    soul: [
      tr('Chant Gayatri Mantra daily',
         'रोज़ गायत्री मंत्र का जाप करें',
         'રોજ ગાયત્રી મંત્રનો જાપ કરો',
         'दररोज गायत्री मंत्राचा जप करा',
         'প্রতিদিন গায়ত্রী মন্ত্র জপ করুন',
         'ಪ್ರತಿದಿನ ಗಾಯತ್ರಿ ಮಂತ್ರ ಜಪಿಸಿ',
         'தினமும் காயத்ரி மந்திரத்தை ஜபியுங்கள்',
         'ప్రతిరోజు గాయత్రీ మంత్రం జపించండి'),
      tr('Feed dog and crow',
         'कुत्ते और कौवे को खाना खिलाएं',
         'કૂતરા અને કાગડાને ખવડાવો',
         'कुत्रा आणि कावळ्याला अन्न द्या',
         'কুকুর এবং কাককে খাওয়ান',
         'ನಾಯಿ ಮತ್ತು ಕಾಗೆಗೆ ಆಹಾರ ನೀಡಿ',
         'நாய்க்கும் காக்கைக்கும் உணவளியுங்கள்',
         'కుక్క మరియు కాకికి ఆహారం పెట్టండి'),
      tr('Avoid non-veg and liquor',
         'मांसाहार और शराब से परहेज़ करें',
         'માંસાહાર અને દારૂથી દૂર રહો',
         'मांसाहार आणि दारू टाळा',
         'আমিষ খাবার এবং মদ্যপান এড়িয়ে চলুন',
         'ಮಾಂಸಾಹಾರ ಮತ್ತು ಮದ್ಯವನ್ನು ತ್ಯಜಿಸಿ',
         'அசைவ உணவையும் மதுவையும் தவிருங்கள்',
         'మాంసాహారం మరియు మద్యం మానుకోండి'),
    ],
  },
  5: {
    mind: [
      tr('Place Lord Vishnu photo in West zone',
         'पश्चिम क्षेत्र में भगवान विष्णु की तस्वीर लगाएं',
         'પશ્ચિમ ઝોનમાં ભગવાન વિષ્ણુનો ફોટો મૂકો',
         'पश्चिम भागात भगवान विष्णूचा फोटो ठेवा',
         'পশ্চিম অংশে ভগবান বিষ্ণুর ছবি রাখুন',
         'ಪಶ್ಚಿಮ ವಲಯದಲ್ಲಿ ವಿಷ್ಣುವಿನ ಫೋಟೋ ಇಡಿ',
         'மேற்குப் பகுதியில் விஷ்ணு பகவானின் புகைப்படத்தை வையுங்கள்',
         'పడమర భాగంలో విష్ణుమూర్తి ఫోటోను ఉంచండి'),
      tr('Keep Mountain picture in South-West without water',
         'दक्षिण-पश्चिम में बिना पानी वाली पहाड़ की तस्वीर रखें',
         'દક્ષિણ-પશ્ચિમમાં પાણી વગરના પર્વતનું ચિત્ર રાખો',
         'नैऋत्येला पाणी नसलेल्या डोंगराचे चित्र ठेवा',
         'দক্ষিণ-পশ্চিমে জল ছাড়া পাহাড়ের ছবি রাখুন',
         'ನೈऋತ್ಯದಲ್ಲಿ ನೀರಿಲ್ಲದ ಪರ್ವತದ ಚಿತ್ರವನ್ನು ಇಡಿ',
         'தென்மேற்கில் தண்ணீர் இல்லாத மலைப் படத்தை வையுங்கள்',
         'నైరుతిలో నీరు లేని పర్వత చిత్రాన్ని ఉంచండి'),
    ],
    body: [
      tr('Keep Green handkerchief',
         'हरे रंग का रुमाल रखें',
         'લીલો રૂમાલ રાખો',
         'हिरवा रुमाल ठेवा',
         'সবুজ রুমাল রাখুন',
         'ಹಸಿರು ಕರವಸ್ತ್ರ ಇಟ್ಟುಕೊಳ್ಳಿ',
         'பச்சை நிற கைக்குட்டையை வையுங்கள்',
         'ఆకుపచ్చ రుమాలు ఉంచుకోండి'),
      tr('Keep Mercury Yantra',
         'बुध यंत्र रखें',
         'બુધ યંત્ર રાખો',
         'बुध यंत्र ठेवा',
         'বুধ যন্ত্র রাখুন',
         'ಬುಧ ಯಂತ್ರ ಇಡಿ',
         'புத யந்திரம் வையுங்கள்',
         'బుధ యంత్రం ఉంచండి'),
    ],
    soul: [
      tr('Do Vishnu Path daily',
         'रोज़ विष्णु पाठ करें',
         'રોજ વિષ્ણુ પાઠ કરો',
         'दररोज विष्णू पाठ करा',
         'প্রতিদিন বিষ্ণু পাঠ করুন',
         'ಪ್ರತಿದಿನ ವಿಷ್ಣು ಪಠಣ ಮಾಡಿ',
         'தினமும் விஷ்ணு பாராயணம் செய்யுங்கள்',
         'ప్రతిరోజు విష్ణు పారాయణం చేయండి'),
      tr('Give Green Pulses to Birds',
         'पक्षियों को हरी दाल खिलाएं',
         'પક્ષીઓને લીલી દાળ ખવડાવો',
         'पक्ष्यांना हिरवी डाळ द्या',
         'পাখিদের সবুজ ডাল খাওয়ান',
         'ಪಕ್ಷಿಗಳಿಗೆ ಹಸಿರು ಬೇಳೆ ನೀಡಿ',
         'பறவைகளுக்கு பச்சைப் பயறு கொடுங்கள்',
         'పక్షులకు పచ్చి పప్పు పెట్టండి'),
    ],
  },
  6: {
    mind: [
      tr('Keep beautiful decorative objects in South-East zone',
         'दक्षिण-पूर्व क्षेत्र में सुंदर सजावटी वस्तुएं रखें',
         'દક્ષિણ-પૂર્વ ઝોનમાં સુંદર સુશોભન વસ્તુઓ રાખો',
         'आग्नेय भागात सुंदर सजावटीच्या वस्तू ठेवा',
         'দক্ষিণ-পূর্ব অংশে সুন্দর সাজসজ্জার জিনিস রাখুন',
         'ಆಗ್ನೇಯ ವಲಯದಲ್ಲಿ ಸುಂದರ ಅಲಂಕಾರಿಕ ವಸ್ತುಗಳನ್ನು ಇಡಿ',
         'தென்கிழக்குப் பகுதியில் அழகான அலங்கார பொருட்களை வையுங்கள்',
         'ఆగ్నేయ భాగంలో అందమైన అలంకార వస్తువులను ఉంచండి'),
      tr('Keep Venus-related artwork in South-East',
         'दक्षिण-पूर्व में शुक्र से संबंधित कलाकृति रखें',
         'દક્ષિણ-પૂર્વમાં શુક્ર સંબંધિત કલાકૃતિ રાખો',
         'आग्नेयेला शुक्राशी संबंधित कलाकृती ठेवा',
         'দক্ষিণ-পূর্বে শুক্র সম্পর্কিত শিল্পকর্ম রাখুন',
         'ಆಗ್ನೇಯದಲ್ಲಿ ಶುಕ್ರ ಗ್ರಹಕ್ಕೆ ಸಂಬಂಧಿಸಿದ ಕಲಾಕೃತಿ ಇಡಿ',
         'தென்கிழக்கில் சுக்கிரனுடன் தொடர்புடைய கலைப்பொருளை வையுங்கள்',
         'ఆగ్నేయంలో శుక్రునికి సంబంధించిన కళాకృతిని ఉంచండి'),
      tr('Keep the house clean and well decorated',
         'घर को साफ और अच्छी तरह सजाकर रखें',
         'ઘરને સ્વચ્છ અને સુવ્યવસ્થિત રાખો',
         'घर स्वच्छ आणि व्यवस्थित सजवलेले ठेवा',
         'বাড়ি পরিষ্কার এবং সুসজ্জিত রাখুন',
         'ಮನೆಯನ್ನು ಸ್ವಚ್ಛವಾಗಿ ಮತ್ತು ಅಲಂಕಾರವಾಗಿ ಇಡಿ',
         'வீட்டை சுத்தமாகவும் அழகாக அலங்கரிக்கவும் வையுங்கள்',
         'ఇంటిని పరిశుభ్రంగా, అందంగా అలంకరించి ఉంచండి'),
    ],
    body: [
      tr('Keep Venus Yantra',
         'शुक्र यंत्र रखें',
         'શુક્ર યંત્ર રાખો',
         'शुक्र यंत्र ठेवा',
         'শুক্র যন্ত্র রাখুন',
         'ಶುಕ್ರ ಯಂತ್ರ ಇಡಿ',
         'சுக்கிர யந்திரம் வையுங்கள்',
         'శుక్ర యంత్రం ఉంచండి'),
      tr('Wear a silver/white metal bracelet',
         'चांदी/सफेद धातु का कंगन पहनें',
         'ચાંદી/સફેદ ધાતુનું બ્રેસલેટ પહેરો',
         'चांदी/पांढऱ्या धातूचे कंकण घाला',
         'রূপা/সাদা ধাতুর ব্রেসলেট পরুন',
         'ಬೆಳ್ಳಿ/ಬಿಳಿ ಲೋಹದ ಕಡಗವನ್ನು ಧರಿಸಿ',
         'வெள்ளி/வெள்ளை உலோக காப்பு அணியுங்கள்',
         'వెండి/తెలుపు లోహపు కంకణం ధరించండి'),
      tr('Keep a white or pink handkerchief with you',
         'अपने पास सफेद या गुलाबी रुमाल रखें',
         'તમારી પાસે સફેદ અથવા ગુલાબી રૂમાલ રાખો',
         'तुमच्याजवळ पांढरा किंवा गुलाबी रुमाल ठेवा',
         'নিজের কাছে সাদা বা গোলাপি রুমাল রাখুন',
         'ನಿಮ್ಮ ಬಳಿ ಬಿಳಿ ಅಥವಾ ಗುಲಾಬಿ ಕರವಸ್ತ್ರವನ್ನು ಇಟ್ಟುಕೊಳ್ಳಿ',
         'உங்களுடன் வெள்ளை அல்லது இளஞ்சிவப்பு கைக்குட்டையை வையுங்கள்',
         'మీ వద్ద తెలుపు లేదా గులాబీ రుమాలు ఉంచుకోండి'),
    ],
    soul: [
      tr('Worship Goddess Lakshmi',
         'देवी लक्ष्मी की पूजा करें',
         'દેવી લક્ષ્મીની પૂજા કરો',
         'देवी लक्ष्मीची पूजा करा',
         'দেবী লক্ষ্মীর পূজা করুন',
         'ಲಕ್ಷ್ಮಿ ದೇವಿಯನ್ನು ಪೂಜಿಸಿ',
         'லக்ஷ்மி தேவியை வழிபடுங்கள்',
         'లక్ష్మీదేవిని పూజించండి'),
      tr('Donate white sweets on Friday',
         'शुक्रवार को सफेद मिठाई दान करें',
         'શુક્રવારે સફેદ મીઠાઈનું દાન કરો',
         'शुक्रवारी पांढरी मिठाई दान करा',
         'শুক্রবার সাদা মিষ্টি দান করুন',
         'ಶುಕ್ರವಾರ ಬಿಳಿ ಸಿಹಿತಿಂಡಿಯನ್ನು ದಾನ ಮಾಡಿ',
         'வெள்ளிக்கிழமை வெள்ளை இனிப்புகளை தானம் செய்யுங்கள்',
         'శుక్రవారం తెల్లని మిఠాయిని దానం చేయండి'),
      tr('Respect women and maintain cleanliness',
         'महिलाओं का सम्मान करें और स्वच्छता बनाए रखें',
         'મહિલાઓનું સન્માન કરો અને સ્વચ્છતા જાળવો',
         'स्त्रियांचा आदर करा आणि स्वच्छता राखा',
         'নারীদের সম্মান করুন এবং পরিচ্ছন্নতা বজায় রাখুন',
         'ಮಹಿಳೆಯರನ್ನು ಗೌರವಿಸಿ ಮತ್ತು ಸ್ವಚ್ಛತೆ ಕಾಪಾಡಿ',
         'பெண்களை மதித்து சுத்தத்தை பேணுங்கள்',
         'మహిళలను గౌరవించి, పరిశుభ్రతను పాటించండి'),
    ],
  },
  7: {
    mind: [
      tr('Keep 7 rods wind chimes in west zone of your house',
         'अपने घर के पश्चिम क्षेत्र में 7 छड़ों वाली विंड चाइम रखें',
         'તમારા ઘરના પશ્ચિમ ઝોનમાં 7 સળિયાવાળા વિન્ડ ચાઇમ્સ રાખો',
         'तुमच्या घराच्या पश्चिम भागात 7 दांड्यांची विंड चाइम ठेवा',
         'আপনার বাড়ির পশ্চিম অংশে ৭টি রড-এর উইন্ড চাইম রাখুন',
         'ನಿಮ್ಮ ಮನೆಯ ಪಶ್ಚಿಮ ವಲಯದಲ್ಲಿ 7 ಕಡ್ಡಿಗಳ ವಿಂಡ್ ಚೈಮ್ ಇಡಿ',
         'உங்கள் வீட்டின் மேற்குப் பகுதியில் 7 கம்பிகள் கொண்ட காற்று மணியை வையுங்கள்',
         'మీ ఇంటి పడమర భాగంలో 7 కడ్డీల విండ్ చైమ్ ఉంచండి'),
      tr('Draw swastika at the entrance of house',
         'घर के प्रवेश द्वार पर स्वस्तिक बनाएं',
         'ઘરના પ્રવેશદ્વાર પર સ્વસ્તિક દોરો',
         'घराच्या प्रवेशद्वारावर स्वस्तिक काढा',
         'বাড়ির প্রবেশদ্বারে স্বস্তিক আঁকুন',
         'ಮನೆಯ ಪ್ರವೇಶದ್ವಾರದಲ್ಲಿ ಸ್ವಸ್ತಿಕ ಬಿಡಿಸಿ',
         'வீட்டு நுழைவாயிலில் ஸ்வஸ்திகா வரையுங்கள்',
         'ఇంటి ప్రవేశ ద్వారం వద్ద స్వస్తిక గీయండి'),
      tr('Name your house',
         'अपने घर का एक नाम रखें',
         'તમારા ઘરનું નામ રાખો',
         'तुमच्या घराला एक नाव द्या',
         'আপনার বাড়ির একটি নাম দিন',
         'ನಿಮ್ಮ ಮನೆಗೆ ಒಂದು ಹೆಸರನ್ನು ಇಡಿ',
         'உங்கள் வீட்டிற்கு ஒரு பெயர் வையுங்கள்',
         'మీ ఇంటికి ఒక పేరు పెట్టుకోండి'),
    ],
    body: [
      tr('Wear silver chain bracelet / watch',
         'चांदी की चेन कंगन / घड़ी पहनें',
         'ચાંદીની ચેન બ્રેસલેટ / ઘડિયાળ પહેરો',
         'चांदीची साखळी कंगन / घड्याळ घाला',
         'রূপার চেইন ব্রেসলেট / ঘড়ি পরুন',
         'ಬೆಳ್ಳಿಯ ಸರದ ಕಡಗ / ಗಡಿಯಾರವನ್ನು ಧರಿಸಿ',
         'வெள்ளி சங்கிலி காப்பு / கடிகாரம் அணியுங்கள்',
         'వెండి గొలుసు కంకణం / గడియారం ధరించండి'),
      tr('Keep Ketu Yantra',
         'केतु यंत्र रखें',
         'કેતુ યંત્ર રાખો',
         'केतू यंत्र ठेवा',
         'কেতু যন্ত্র রাখুন',
         'ಕೇತು ಯಂತ್ರ ಇಡಿ',
         'கேது யந்திரம் வையுங்கள்',
         'కేతు యంత్రం ఉంచండి'),
      tr('Wear light colour clothes like white, light blue, light green etc.',
         'सफेद, हल्के नीले, हल्के हरे जैसे हल्के रंग के कपड़े पहनें',
         'સફેદ, આછા વાદળી, આછા લીલા જેવા હળવા રંગના કપડાં પહેરો',
         'पांढरा, फिकट निळा, फिकट हिरवा यांसारखे फिकट रंगाचे कपडे घाला',
         'সাদা, হালকা নীল, হালকা সবুজের মতো হালকা রঙের পোশাক পরুন',
         'ಬಿಳಿ, ತಿಳಿ ನೀಲಿ, ತಿಳಿ ಹಸಿರಿನಂತಹ ತಿಳಿ ಬಣ್ಣದ ಬಟ್ಟೆಗಳನ್ನು ಧರಿಸಿ',
         'வெள்ளை, வெளிர் நீலம், வெளிர் பச்சை போன்ற வெளிர் நிற ஆடைகளை அணியுங்கள்',
         'తెలుపు, లేత నీలం, లేత ఆకుపచ్చ వంటి లేత రంగుల దుస్తులు ధరించండి'),
    ],
    soul: [
      tr('Worship Lord Ganesh daily',
         'रोज़ भगवान गणेश की पूजा करें',
         'રોજ ભગવાન ગણેશની પૂજા કરો',
         'दररोज भगवान गणेशाची पूजा करा',
         'প্রতিদিন ভগবান গণেশের পূজা করুন',
         'ಪ್ರತಿದಿನ ಗಣೇಶನನ್ನು ಪೂಜಿಸಿ',
         'தினமும் விநாயகரை வழிபடுங்கள்',
         'ప్రతిరోజు గణేశుడిని పూజించండి'),
      tr('Give food to dogs',
         'कुत्तों को खाना खिलाएं',
         'કૂતરાઓને ખોરાક આપો',
         'कुत्र्यांना अन्न द्या',
         'কুকুরদের খাবার দিন',
         'ನಾಯಿಗಳಿಗೆ ಆಹಾರ ನೀಡಿ',
         'நாய்களுக்கு உணவளியுங்கள்',
         'కుక్కలకు ఆహారం పెట్టండి'),
      tr('Do fast on Thursday',
         'गुरुवार को व्रत रखें',
         'ગુરુવારે ઉપવાસ કરો',
         'गुरुवारी उपवास करा',
         'বৃহস্পতিবার উপবাস করুন',
         'ಗುರುವಾರ ಉಪವಾಸ ಮಾಡಿ',
         'வியாழக்கிழமை விரதம் இருங்கள்',
         'గురువారం ఉపవాసం ఉండండి'),
    ],
  },
  8: {
    mind: [
      tr('Keep Money plant in north zone',
         'उत्तर क्षेत्र में मनी प्लांट रखें',
         'ઉત્તર ઝોનમાં મની પ્લાન્ટ રાખો',
         'उत्तर भागात मनी प्लांट ठेवा',
         'উত্তর অংশে মানি প্ল্যান্ট রাখুন',
         'ಉತ್ತರ ವಲಯದಲ್ಲಿ ಮನಿ ಪ್ಲಾಂಟ್ ಇಡಿ',
         'வடக்குப் பகுதியில் மணி பிளாண்ட் செடியை வையுங்கள்',
         'ఉత్తర భాగంలో మనీ ప్లాంట్ ఉంచండి'),
      tr('Place holy water in west of house',
         'घर के पश्चिम में पवित्र जल रखें',
         'ઘરના પશ્ચિમમાં પવિત્ર જળ મૂકો',
         'घराच्या पश्चिमेला पवित्र जल ठेवा',
         'বাড়ির পশ্চিমে পবিত্র জল রাখুন',
         'ಮನೆಯ ಪಶ್ಚಿಮದಲ್ಲಿ ಪವಿತ್ರ ನೀರನ್ನು ಇಡಿ',
         'வீட்டின் மேற்கில் புனித நீரை வையுங்கள்',
         'ఇంటి పడమర భాగంలో పవిత్ర జలాన్ని ఉంచండి'),
      tr('Place brass pot of coins in West',
         'पश्चिम में सिक्कों से भरा पीतल का बर्तन रखें',
         'પશ્ચિમમાં સિક્કાઓથી ભરેલો પિત્તળનો વાસણ મૂકો',
         'पश्चिमेला नाण्यांनी भरलेले पितळेचे भांडे ठेवा',
         'পশ্চিমে মুদ্রা ভর্তি পিতলের পাত্র রাখুন',
         'ಪಶ್ಚಿಮದಲ್ಲಿ ನಾಣ್ಯಗಳ ಹಿತ್ತಾಳೆ ಪಾತ್ರೆಯನ್ನು ಇಡಿ',
         'மேற்கில் நாணயங்கள் நிரம்பிய பித்தளை பாத்திரத்தை வையுங்கள்',
         'పడమర భాగంలో నాణేలతో నిండిన ఇత్తడి పాత్రను ఉంచండి'),
      tr('Keep crystals in North-east',
         'उत्तर-पूर्व में क्रिस्टल रखें',
         'ઉત્તર-પૂર્વમાં ક્રિસ્ટલ રાખો',
         'ईशान्येला क्रिस्टल ठेवा',
         'উত্তর-পূর্বে ক্রিস্টাল রাখুন',
         'ಈಶಾನ್ಯದಲ್ಲಿ ಸ್ಫಟಿಕಗಳನ್ನು ಇಡಿ',
         'வடகிழக்கில் படிகங்களை வையுங்கள்',
         'ఈశాన్యంలో స్ఫటికాలను ఉంచండి'),
    ],
    body: [
      tr('Wear Crystal bracelet on wrist',
         'कलाई पर क्रिस्टल कंगन पहनें',
         'કાંડા પર ક્રિસ્ટલ બ્રેસલેટ પહેરો',
         'मनगटावर क्रिस्टल कंकण घाला',
         'কব্জিতে ক্রিস্টাল ব্রেসলেট পরুন',
         'ಮಣಿಕಟ್ಟಿಗೆ ಸ್ಫಟಿಕ ಕಡಗವನ್ನು ಧರಿಸಿ',
         'மணிக்கட்டில் படிக காப்பு அணியுங்கள்',
         'మణికట్టుకు స్ఫటిక కంకణం ధరించండి'),
      tr('Keep Blue pen with you',
         'अपने पास नीली कलम रखें',
         'તમારી પાસે વાદળી પેન રાખો',
         'तुमच्याजवळ निळे पेन ठेवा',
         'নিজের কাছে নীল কলম রাখুন',
         'ನಿಮ್ಮ ಬಳಿ ನೀಲಿ ಪೆನ್ ಇಟ್ಟುಕೊಳ್ಳಿ',
         'உங்களுடன் நீல நிற பேனாவை வையுங்கள்',
         'మీ వద్ద నీలిరంగు పెన్ను ఉంచుకోండి'),
      tr('Keep Saturn Yantra',
         'शनि यंत्र रखें',
         'શનિ યંત્ર રાખો',
         'शनी यंत्र ठेवा',
         'শনি যন্ত্র রাখুন',
         'ಶನಿ ಯಂತ್ರ ಇಡಿ',
         'சனி யந்திரம் வையுங்கள்',
         'శని యంత్రం ఉంచండి'),
      tr('Keep crystals stone with you',
         'अपने पास क्रिस्टल पत्थर रखें',
         'તમારી પાસે ક્રિસ્ટલ સ્ટોન રાખો',
         'तुमच्याजवळ क्रिस्टल स्टोन ठेवा',
         'নিজের কাছে ক্রিস্টাল পাথর রাখুন',
         'ನಿಮ್ಮ ಬಳಿ ಸ್ಫಟಿಕ ಕಲ್ಲನ್ನು ಇಟ್ಟುಕೊಳ್ಳಿ',
         'உங்களுடன் படிகக் கல்லை வையுங்கள்',
         'మీ వద్ద స్ఫటిక రాయిని ఉంచుకోండి'),
    ],
    soul: [
      tr('Plant triveni trees at any place',
         'किसी भी स्थान पर त्रिवेणी (पीपल, बरगद, नीम) के पेड़ लगाएं',
         'કોઈપણ સ્થળે ત્રિવેણી વૃક્ષો વાવો',
         'कोणत्याही ठिकाणी त्रिवेणी वृक्ष लावा',
         'যেকোনো জায়গায় ত্রিবেণী গাছ লাগান',
         'ಯಾವುದೇ ಸ್ಥಳದಲ್ಲಿ ತ್ರಿವೇಣಿ ಮರಗಳನ್ನು ನೆಡಿ',
         'எந்த இடத்திலும் திரிவேணி மரங்களை நடுங்கள்',
         'ఏదైనా ప్రదేశంలో త్రివేణి చెట్లను నాటండి'),
      tr('Respect all service providers in your life',
         'अपने जीवन में सभी सेवा प्रदाताओं का सम्मान करें',
         'તમારા જીવનમાં તમામ સેવા પ્રદાતાઓનું સન્માન કરો',
         'तुमच्या आयुष्यातील सर्व सेवा देणाऱ्यांचा आदर करा',
         'আপনার জীবনের সকল সেবা প্রদানকারীদের সম্মান করুন',
         'ನಿಮ್ಮ ಜೀವನದಲ್ಲಿ ಎಲ್ಲಾ ಸೇವಾ ಪೂರೈಕೆದಾರರನ್ನು ಗೌರವಿಸಿ',
         'உங்கள் வாழ்க்கையில் அனைத்து சேவை வழங்குபவர்களையும் மதியுங்கள்',
         'మీ జీవితంలో అన్ని సేవా ప్రదాతలను గౌరవించండి'),
      tr('Distribute salty food on Saturday',
         'शनिवार को नमकीन भोजन बांटें',
         'શનિવારે ખારો ખોરાક વહેંચો',
         'शनिवारी खारट अन्न वाटा',
         'শনিবার নোনতা খাবার বিতরণ করুন',
         'ಶನಿವಾರ ಉಪ್ಪಿನ ಆಹಾರವನ್ನು ಹಂಚಿ',
         'சனிக்கிழமை உப்பு உணவை பகிருங்கள்',
         'శనివారం ఉప్పు కలిగిన ఆహారాన్ని పంచండి'),
      tr('Do not eat non-veg and liquor on Saturday',
         'शनिवार को मांसाहार और शराब का सेवन न करें',
         'શનિવારે માંસાહાર અને દારૂનું સેવન ન કરો',
         'शनिवारी मांसाहार आणि दारू सेवन करू नका',
         'শনিবার আমিষ খাবার এবং মদ্যপান করবেন না',
         'ಶನಿವಾರ ಮಾಂಸಾಹಾರ ಮತ್ತು ಮದ್ಯವನ್ನು ಸೇವಿಸಬೇಡಿ',
         'சனிக்கிழமை அசைவ உணவும் மதுவும் தவிருங்கள்',
         'శనివారం మాంసాహారం మరియు మద్యం సేవించవద్దు'),
    ],
  },
  9: {
    mind: [
      tr('Keep red objects in the South zone',
         'दक्षिण क्षेत्र में लाल वस्तुएं रखें',
         'દક્ષિણ ઝોનમાં લાલ વસ્તુઓ રાખો',
         'दक्षिण भागात लाल वस्तू ठेवा',
         'দক্ষিণ অংশে লাল জিনিস রাখুন',
         'ದಕ್ಷಿಣ ವಲಯದಲ್ಲಿ ಕೆಂಪು ವಸ್ತುಗಳನ್ನು ಇಡಿ',
         'தெற்குப் பகுதியில் சிவப்பு பொருட்களை வையுங்கள்',
         'దక్షిణ భాగంలో ఎరుపు వస్తువులను ఉంచండి'),
      tr('Keep a picture of Hanuman in the South zone',
         'दक्षिण क्षेत्र में हनुमान जी की तस्वीर रखें',
         'દક્ષિણ ઝોનમાં હનુમાનજીનું ચિત્ર રાખો',
         'दक्षिण भागात हनुमानाचे चित्र ठेवा',
         'দক্ষিণ অংশে হনুমানের ছবি রাখুন',
         'ದಕ್ಷಿಣ ವಲಯದಲ್ಲಿ ಹನುಮಂತನ ಚಿತ್ರವನ್ನು ಇಡಿ',
         'தெற்குப் பகுதியில் அனுமனின் படத்தை வையுங்கள்',
         'దక్షిణ భాగంలో హనుమంతుని చిత్రం ఉంచండి'),
      tr('Keep the South zone clean and balanced',
         'दक्षिण क्षेत्र को साफ और संतुलित रखें',
         'દક્ષિણ ઝોનને સ્વચ્છ અને સંતુલિત રાખો',
         'दक्षिण भाग स्वच्छ आणि संतुलित ठेवा',
         'দক্ষিণ অংশ পরিষ্কার এবং সুষম রাখুন',
         'ದಕ್ಷಿಣ ವಲಯವನ್ನು ಸ್ವಚ್ಛವಾಗಿ ಮತ್ತು ಸಮತೋಲನದಲ್ಲಿಡಿ',
         'தெற்குப் பகுதியை சுத்தமாகவும் சமநிலையிலும் வையுங்கள்',
         'దక్షిణ భాగాన్ని పరిశుభ్రంగా, సమతుల్యంగా ఉంచండి'),
    ],
    body: [
      tr('Keep Mars Yantra',
         'मंगल यंत्र रखें',
         'મંગળ યંત્ર રાખો',
         'मंगळ यंत्र ठेवा',
         'মঙ্গল যন্ত্র রাখুন',
         'ಮಂಗಳ ಯಂತ್ರ ಇಡಿ',
         'செவ்வாய் யந்திரம் வையுங்கள்',
         'కుజ యంత్రం ఉంచండి'),
      tr('Wear a copper bracelet',
         'तांबे का कंगन पहनें',
         'તાંબાનું બ્રેસલેટ પહેરો',
         'तांब्याचे कंकण घाला',
         'তামার ব্রেসলেট পরুন',
         'ತಾಮ್ರದ ಕಡಗವನ್ನು ಧರಿಸಿ',
         'செம்பு காப்பு அணியுங்கள்',
         'రాగి కంకణం ధరించండి'),
      tr('Keep a red handkerchief with you',
         'अपने पास लाल रुमाल रखें',
         'તમારી પાસે લાલ રૂમાલ રાખો',
         'तुमच्याजवळ लाल रुमाल ठेवा',
         'নিজের কাছে লাল রুমাল রাখুন',
         'ನಿಮ್ಮ ಬಳಿ ಕೆಂಪು ಕರವಸ್ತ್ರವನ್ನು ಇಟ್ಟುಕೊಳ್ಳಿ',
         'உங்களுடன் சிவப்பு கைக்குட்டையை வையுங்கள்',
         'మీ వద్ద ఎరుపు రుమాలు ఉంచుకోండి'),
    ],
    soul: [
      tr('Worship Lord Hanuman',
         'भगवान हनुमान की पूजा करें',
         'ભગવાન હનુમાનની પૂજા કરો',
         'भगवान हनुमानाची पूजा करा',
         'ভগবান হনুমানের পূজা করুন',
         'ಹನುಮಂತನನ್ನು ಪೂಜಿಸಿ',
         'அனுமனை வழிபடுங்கள்',
         'హనుమంతుడిని పూజించండి'),
      tr('Chant Hanuman Chalisa',
         'हनुमान चालीसा का पाठ करें',
         'હનુમાન ચાલીસાનો પાઠ કરો',
         'हनुमान चालीसा पठण करा',
         'হনুমান চালিশা পাঠ করুন',
         'ಹನುಮಾನ್ ಚಾಲೀಸಾ ಪಠಿಸಿ',
         'அனுமான் சாலிசாவை ஓதுங்கள்',
         'హనుమాన్ చాలీసా పఠించండి'),
      tr('Donate red lentils on Tuesday',
         'मंगलवार को लाल दाल दान करें',
         'મંગળવારે લાલ દાળનું દાન કરો',
         'मंगळवारी लाल डाळ दान करा',
         'মঙ্গলবার লাল ডাল দান করুন',
         'ಮಂಗಳವಾರ ಕೆಂಪು ಬೇಳೆಯನ್ನು ದಾನ ಮಾಡಿ',
         'செவ்வாய்க்கிழமை சிவப்பு பருப்பை தானம் செய்யுங்கள்',
         'మంగళవారం ఎర్రని పప్పును దానం చేయండి'),
    ],
  },
};
